import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = {
  variant: 'green' | 'yellow' | 'red' | 'blue' | 'gray';
  children?: ReactNode;
};

export const BadgeIndicator = ({ variant, children }: Props) => {
  return (
    <span
      className={twMerge(
        'inline-flex items-center text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full',
        variant === 'green'
          ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
          : variant === 'yellow'
          ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300'
          : variant === 'red'
          ? 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300'
          : variant === 'gray'
          ? 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300'
          : 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
      )}
    >
      <span
        className={twMerge(
          'w-2 h-2 mr-1 rounded-full',
          variant === 'green'
            ? 'bg-green-500'
            : variant === 'yellow'
            ? 'bg-yellow-500'
            : variant === 'red'
            ? 'bg-red-500'
            : variant === 'gray'
            ? 'bg-gray-500'
            : 'bg-blue-500',
        )}
      />
      {children}
    </span>
  );
};
